import { DataDisplayEvent, DropdownSelectionEvent } from "@mcleod/components";
import { AutogenLayoutNumberOfMovesDetail } from "./autogen/AutogenLayoutNumberOfMovesDetail";
import { CarrierScorecardUtil } from "./CarrierScorecardUtil";
import { StringUtil } from "@mcleod/core";

const NUMMOVES = "B";
const TOTALSHIPMENTS = "S";
const CARRIERCAPACITY = "C";

export class NumberOfMovesDetail extends AutogenLayoutNumberOfMovesDetail {
    textboxMeasureOnDataDisplay(event: DataDisplayEvent) {
        const measure = event.rowData.get("measure");
        this.syncLayoutWithMeasure(measure);
    }

    textboxMeasureAfterDropdownSelection(event: DropdownSelectionEvent) {
        const measure = event.selection?.value;
        this.syncLayoutWithMeasure(measure);
    }

    syncLayoutWithMeasure(measure: string) {
        const isNull = StringUtil.isEmptyString(measure);
        const isNumMovesMeasure = NUMMOVES === measure;
        const isTotalShipmentsMeasure = TOTALSHIPMENTS === measure;
        const isCarrierCapacityMeasure = CARRIERCAPACITY === measure;
        this.textboxPoints.visible = isNumMovesMeasure;
        this.textboxWeight.visible = !isNumMovesMeasure;
        this.textboxWeight.required = !isNumMovesMeasure;
        this.labelAdded.visible = !isNumMovesMeasure;
        this.labelSubtracted.visible = !isNumMovesMeasure;

        this.panelNoMeasure.visible = isNull;
        this.panelScoreDetailsNumMoves.visible = isNumMovesMeasure;
        this.panelScoreDetailsTotalShipments.visible = isTotalShipmentsMeasure;
        this.panelScoreDetailsCarrierCapacity.visible = isCarrierCapacityMeasure;

        CarrierScorecardUtil.syncWeightSuffix(this.textboxWeight, this);
    }
}
